export default __webpack_public_path__ + "static/media/india-2019.7a3acb87.jpg";